/**
 * 346 (#943): customer-facing dates and times in Malaysia wall-clock time, whatever zone the device is set to. Cars are
 * collected at Malaysian locations and the booking form's slots are Malaysia time (`useDateTimePicker.ts`), so a
 * customer whose phone is set elsewhere must still read the time they booked. The bookings list already did this
 * (#541); the booking page and three dates did not.
 */
export const RENTAL_ZONE = 'Asia/Kuala_Lumpur';

/** A date and time, e.g. "Aug 1, 2026, 5:00 PM" (`medium`) or "8/1/26, 5:00 PM" (`short`), in Malaysia time. */
export function mytDateTime(iso: string, style: 'medium' | 'short' = 'medium'): string {
  return new Date(iso).toLocaleString(undefined, {
    timeZone: RENTAL_ZONE,
    dateStyle: style,
    timeStyle: 'short',
  });
}

/** A date alone, the Malaysia day (01:30 MYT on the 12th is the 12th, even where it is still the 11th). */
export function mytDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { timeZone: RENTAL_ZONE });
}

/** 405: a time alone, e.g. "9:42 PM", in Malaysia time. */
export function mytClock(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, { timeZone: RENTAL_ZONE, timeStyle: 'short' });
}

/** 408: a day and time without the year, e.g. "Oct 20, 5:44 PM", in Malaysia time (when a fuel reading was taken). */
export function mytDayTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    timeZone: RENTAL_ZONE,
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
